import React, { useState } from "react";
import { Button, Box, Icon } from "@showitinc/showit-wc";
import UIActions from "../actions/UIActions";
import SiteDesignStore from "../stores/SiteDesignStore";
import AppConstants from "../constants/AppConstants";
import styles from "./CanvasSetSiteCanvasProperties.module.css";
import PropertyPanelSectionWrapper from "../app2components/base/PropertyPanelSectionWrapper";

const CanvasSetSiteCanvasProperties = ({ blockContainer, containerType }) => {
  const isPage = containerType === AppConstants.SITE_ITEM_PAGE;

  const canvasSetId = blockContainer.getIn(["currentPageItem", "canvasSet", 0]);
  const [canvasSet, setCanvasSet] = useState(SiteDesignStore.findCanvasSet(canvasSetId));

  const _selectCanvasSet = () => {
    UIActions.selectCanvasSet({ canvasSet });
    UIActions.addActiveItemHistory({
      id: canvasSet.get("id"),
      type: AppConstants.ITEM_TYPE_CANVAS_SET,
      name: canvasSet.get("name"),
    });
  };

  const siteBlock = blockContainer.get("selectedBlock");

  const _selectBlock = () => {
    siteBlock && UIActions.selectSiteBlock({ block: siteBlock });
    UIActions.addActiveItemHistory({
      type: AppConstants.ITEM_TYPE_BLOCK,
    });
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <PropertyPanelSectionWrapper title="Canvas Set Properties" open>
        <Box my={3}>
          <Button
            variant="outline"
            fullWidth
            onSIClick={isPage ? _selectCanvasSet : _selectBlock}
            className={styles.canvasSetEditButton}
          >
            <Icon size="20" type={canvasSetId ? "canvasSet" : "siteCanvas"} />
            &nbsp; Edit {isPage ? "Canvas Set" : "Site Canvas"}
          </Button>
        </Box>
      </PropertyPanelSectionWrapper>
    </div>
  );
};

export default CanvasSetSiteCanvasProperties;
